// Hash-navigation helpers for canonical content pages.
// Route and hash scrolling for new document-system routes.

import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

export const useContentHashNavigation = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.hash) return;

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.hash, location.pathname, location.search]);

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace('#', '');
    let attempts = 0;
    const maxAttempts = 20;
    let timeoutId: number | null = null;

    const tryScroll = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (attempts++ < maxAttempts) {
        timeoutId = window.setTimeout(tryScroll, 50);
      }
    };

    tryScroll();

    return () => {
      if (timeoutId !== null) window.clearTimeout(timeoutId);
    };
  }, [location.hash, location.pathname]);
};
